$(".testimonial-text .readmore, .testimonial-text .readless").click(function (
  e
) {
  e.preventDefault();
  var trg = $(this).closest(".testimonial-text");
  if (trg.hasClass("expanded")) {
    $("html, body").animate(
      { scrollTop: trg.closest(".page-section").offset().top },
      300
    );
    setTimeout(function () {
      trg.removeClass("expanded");
    }, 300);
  } else trg.addClass("expanded");
});

$(document).ready(function () {
  var windowWidth = $(window).width();
  $(".video-load-thumb").each(function () {
    var video_id = $(this).data("video-id");
    var video_type = $(this).data("video-type");
    var cached = sessionStorage.getItem(
      "video-thumb-" + video_type + "-" + video_id
    );
    var that = $(this);
    if (cached) {
      that.css({ "background-image": 'url("' + cached + '")' });
    } else {
      if (video_type == "vimeo") {
        $.get(
          "https://vimeo.com/api/v2/video/" + video_id + ".json",
          function (data) {
            if (data.length) {
              var image = data[0].thumbnail_large.replace(/_640./, "_1200.");
              that.css({ "background-image": 'url("' + image + '")' });
              sessionStorage.setItem(
                "video-thumb-" + video_type + "-" + video_id,
                image
              );
            }
          }
        );
      } else {
        var image =
          "https://img.youtube.com/vi/" + video_id + "/maxresdefault.jpg";
        that.css({ "background-image": 'url("' + image + '")' });
        sessionStorage.setItem(
          "video-thumb-" + video_type + "-" + video_id,
          image
        );
      }
    }
  });

  function fillImageSlider(slider, source) {
    $.ajax({
      dataType: "json",
      method: "get",
      url: source,
    }).done(function (data) {
      var html = "";
      if (!slider.classList.contains("one-liner")) html += "<div>";
      var i = 0;
      for (let prop in data) {
        if (i > 0 && i % 2 == 0 && !slider.classList.contains("one-liner")) {
          html += "</div><div>";
        }
        html +=
          '<div class="img-wrapepr"><img class="lazyload" data-src="' +
          source +
          "/" +
          data[prop] +
          '"></div>';
        i++;
      }
      if (!slider.classList.contains("one-liner")) html += "</div>";

      slider.innerHTML = html;

      setTimeout(function () {
        $(slider).slick({
          infinite: true,
          cycleSpeed: 300,
          timeout: 0,
          variableWidth: true,
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                variableWidth: false,
                swipeToSlide: true,
              },
            },
          ],
        });
      }, 300);
    });
  }

  var imageSliders = document.querySelectorAll(".image-slider");
  if (imageSliders.length > 0)
    for (var i = 0; i < imageSliders.length; i++) {
      var slider = imageSliders[i];
      var source = slider.getAttribute("data-source");
      if (source) {
        fillImageSlider(slider, source);
      }
    }

  var sttCont = $(".scroll-to-top-container");
  var scrollToTopVisible = false;
  var windowScroll = $(window).scrollTop();
  var lastWindowScroll = windowScroll;

  var dskAddToCart = document.querySelector(".sticky-bar-add-to-cart");
  var mobAddToCart = document.querySelector(".mobile-add-to-cart");
  var mobAddToCartActive = false;
  var addToCartOffset = false;
  var dskAddToCartBottom = false;
  if (mobAddToCart) {
    addToCartOffset = $(".add-to-cart").eq(0).offset().top;

    setInterval(function () {
      addToCartOffset = $(".add-to-cart").eq(0).offset().top;
    }, 2000);

    $(window).resize(function () {
      addToCartOffset = $(".add-to-cart").eq(0).offset().top;
    });
  }

  $(window).scroll(function () {
    windowScroll = $(window).scrollTop();

    if (addToCartOffset !== false) {
      if (
        dskAddToCartBottom === false &&
        windowScroll + $(window).height() + 150 >= $(document).height()
      ) {
        dskAddToCartBottom = true;
        document.body.classList.add("dskAddToCartBottom");
      } else if (
        dskAddToCartBottom !== false &&
        windowScroll + $(window).height() + 250 < $(document).height()
      ) {
        dskAddToCartBottom = false;
        document.body.classList.remove("dskAddToCartBottom");
      }
    }

    if (
      addToCartOffset !== false &&
      windowScroll > addToCartOffset + 40 &&
      !mobAddToCartActive
    ) {
      mobAddToCartActive = true;
      mobAddToCart.classList.add("active");
      dskAddToCart.classList.add("active");
      document
        .querySelector("body")
        .classList.add("mobile-add-to-cart-is-active");
    } else if (
      addToCartOffset !== false &&
      windowScroll < addToCartOffset + 40 &&
      mobAddToCartActive
    ) {
      mobAddToCartActive = false;
      mobAddToCart.classList.remove("active");
      dskAddToCart.classList.remove("active");
      document
        .querySelector("body")
        .classList.remove("mobile-add-to-cart-is-active");
    }

    if (!scrollToTopVisible && windowScroll > 800) {
      sttCont.addClass("shown");
      setTimeout(function () {
        sttCont.addClass("animation");
      }, 10);
      scrollToTopVisible = true;
    } else if (scrollToTopVisible && windowScroll <= 800) {
      sttCont.removeClass("animation");
      setTimeout(function () {
        sttCont.removeClass("shown");
      }, 501);
      scrollToTopVisible = false;
    }

    lastWindowScroll = windowScroll;
  });

  $(".scroll-to-top").click(function (e) {
    e.preventDefault();
    $("html, body").stop(true, false).animate({ scrollTop: 0 }, 500);
  });

  $(".testimonial-text .readmore, .testimonial-text .readless").click(function (
    e
  ) {
    e.preventDefault();
    var trg = $(this).closest(".testimonial-text");
    if (trg.hasClass("expanded")) {
      $("html, body").animate(
        { scrollTop: trg.closest(".page-section").offset().top },
        300
      );
      setTimeout(function () {
        trg.removeClass("expanded");
      }, 30000);
    } else trg.addClass("expanded");
  });
  //  CODE ADDED OCT.17
  $(".testimonial-text .readless").click(function(e){
    e.preventDefault();
    var trg = $(this).closest(".testimonial-text");
    setTimeout(function () {
        trg.removeClass("expanded");
      }, 300);
  })
  // ######################################
  $(".load-more-container .btn").click(function (e) {
    e.preventDefault();
    var cont = $(this)
      .parents(".page-section")
      .find(".written-reviews-container, .video-reviews-container")
      .eq(0);
    var rev = cont.find(".written-review.not-shown, .video-review.not-shown");
    var show = cont.data("show");
    var add = cont.data("add");
    cont.attr("data-show", show + add);
    if (rev.length <= add) $(this).hide();
    rev.slice(0, add).removeClass("not-shown");
  });

  $(".video-testimonials").on(
    "click",
    ".video-testimonial-background",
    function (e) {
      var iframe = $(this).parent().find("iframe");
      if (iframe.length == 0) return;
      var src = iframe.data("src");

      src = src.split("watch?v=");
      if (src.length == 1) {
        src = src[0].split("youtu.be/");
      }
      if (src.length == 1) return;

      src = src[src.length - 1];

      iframe.attr(
        "src",
        "https://www.youtube.com/embed/" + src + "?autoplay=1&modestbranding=1"
      );

      $(this).fadeOut(500);
    }
  );

  var videoPopup = document.querySelector("#video-popup");

  if (videoPopup) {
    function showVideoPopup(src) {
      videoPopup.getElementsByTagName("iframe")[0].setAttribute("src", src);
      videoPopup.classList.add("active");
    }

    function hideVideoPopup() {
      videoPopup.classList.remove("active");
      videoPopup.getElementsByTagName("iframe")[0].setAttribute("src", "");
    }

    var closePopup = videoPopup.getElementsByClassName("popup-close");
    if (closePopup.length)
      closePopup[0].addEventListener("click", function (e) {
        e.preventDefault();
        hideVideoPopup();
      });

    videoPopup.addEventListener("click", hideVideoPopup);

    videoPopup
      .getElementsByClassName("popup-content")[0]
      .addEventListener("click", function (e) {
        e.stopPropagation();
      });

    var video_activators = document.getElementsByClassName("video-activator");
    if (video_activators.length)
      for (var i = 0; i < video_activators.length; i++) {
        video_activators[i].addEventListener("click", function (e) {
          e.preventDefault();

          if ($(window).width() > 767)
            if (
              this.classList.contains("in-siema") &&
              this.closest(".siema-moving") != null
            )
              return;

          var src = this.getAttribute("data-video");
          if (!src) src = this.getAttribute("href");
          if (!src) return;

          src = src.split("watch?v=");
          if (src.length == 1) {
            src = src[0].split("youtu.be/");
          }

          if (src.length > 1) {
            src = src[src.length - 1];
            showVideoPopup(
              "https://www.youtube.com/embed/" +
                src +
                "?autoplay=1&modestbranding=1"
            );
            return;
          }

          if (src.length == 1) {
            src = src[0].split("vimeo.com/video/");
          }

          if (src.length == 1) {
            src = src[0].split("vimeo.com/");
          }
          if (src.length == 1) return;

          src = src[src.length - 1].split("?");

          showVideoPopup(
            "https://player.vimeo.com/video/" + src[0] + "?autoplay=1"
          );
        });
      }
  }

  $(".q-and-a-box .question").click(function () {
    $(this).parent().toggleClass("active");
  });

  $(".faq-categories a").click(function (e) {
    e.preventDefault();
    var target = $(this).data("target");
    if (!target) return false;

    var already_active = $(this).hasClass("active");
    $(".faq-categories a.active").removeClass("active");

    if (!already_active) {
      $(this).addClass("active");
      $(".current-category")
        .removeClass("visually-hidden")
        .find("h3")
        .html($(this).data("title"));
      $(".q-and-a-box").hide();
      $(".q-and-a-box.faq-category-" + target).show();
    } else {
      $(".q-and-a-box").show();
      $(".current-category").addClass("visually-hidden");
    }
  });

  $(".compare .compare-products-wrapper").slick({
    infinite: true,
    cycleSpeed: 300,
    timeout: 0,
    slidesToShow: 4,
    swipeToSlide: true,
    variableWidth: false,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          swipeToSlide: true,
          variableWidth: false,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          swipeToSlide: true,
          variableWidth: true,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  // $(window).resize(function () {
  //   $(".compare .compare-products-wrapper").slick({
  //     infinite: true,
  //     cycleSpeed: 300,
  //     timeout: 0,
  //     slidesToShow: 4,
  //     swipeToSlide: true,
  //     variableWidth: false,
  //     arrows: true,
  //     dots: true,
  //     responsive: [
  //       {
  //         breakpoint: 991,
  //         settings: {
  //           slidesToShow: 3,
  //           swipeToSlide: true,
  //           variableWidth: false,
  //           arrows: true,
  //           dots: true,
  //         },
  //       },
  //       {
  //         breakpoint: 767,
  //         settings: {
  //           slidesToShow: 1,
  //           swipeToSlide: true,
  //           variableWidth: true,
  //           arrows: false,
  //           dots: true,
  //         },
  //       },
  //     ],
  //   });
  // });

  $(".compare-tabs-wrapper a").click(function (e) {
    e.preventDefault();

    $(".compare-tabs-wrapper a").removeClass("active");
    $(this).addClass("active");

    $(".compare .compare-products-wrapper").removeClass("active");
    $(".compare .compare-products-wrapper-" + $(this).data("tab")).addClass(
      "active"
    );

    $(".compare .compare-products-wrapper").slick("unslick");

    $(".compare .compare-products-wrapper").slick({
      infinite: true,
      cycleSpeed: 300,
      timeout: 0,
      slidesToShow: 4,
      swipeToSlide: true,
      variableWidth: false,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            swipeToSlide: true,
            variableWidth: false,
            arrows: true,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            swipeToSlide: true,
            variableWidth: true,
            arrows: false,
            dots: true,
          },
        },
      ],
    });

    setTimeout(function () {
      $(window).resize();
      console.log(1);
    }, 1000);
  });

  $("#header-icons").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
  });

  $("#header-icons-top").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
  });

  if ($(window).width() < 768) {
    $("[data-variants-wrapper]").appendTo("[data-variants-wrapper-mobile]");
  }
});

$(function () {
  setInterval(function () {
    if (!$(".mobile-add-to-cart form .bar-reviews").hasClass("init")) {
      if (
        $(
          ".mobile-add-to-cart form .bar-reviews .stamped-product-reviews-badge .stamped-badge"
        ).length
      ) {
        $(".mobile-add-to-cart form .bar-reviews").addClass("init");

        if (
          $(
            ".mobile-add-to-cart form .bar-reviews .stamped-product-reviews-badge .stamped-badge"
          ).data("rating") != "0.0"
        ) {
          $(".mobile-add-to-cart form .bar-reviews").show();
        }
      }
    }
  }, 500);

  setInterval(function () {
    if (
      $(
        '.cart__submit-control[name="checkout"], #mini-cart .cart-controls .btn:last-of-type'
      ).hasClass("loading")
    ) {
      $(
        '.cart__submit-control[name="checkout"], #mini-cart .cart-controls .btn:last-of-type'
      ).removeClass("loading");
    }
  }, 2000);
});

const activeHtmlInText = () => {
  $(".metafields-short-testimonial").each(function () {
    $this = $(this);
    const textToHtml = $.parseHTML($this.text());
    $this.html(textToHtml);
  });
};

const get_Aspect_ratio = () => {
  $(".image-section-get-aspect-ratio").each(function () {
    const aspectRatio =
      $(this).find("img").height() / $(this).find("img").width();
    const paddingTop = (1 / aspectRatio) * 100;
    $(this).css({ "padding-top": $(this).find("img").height() });
  });
};

const remove_unnecessary_space = () => {
  const $parent = $(".spacer-product-sections").parent();
  counter = 0;
  $parent.find("section").each(function () {
    if ($(this).hasClass("spacer-product-sections")) {
      if (counter == 1 && $(this).prev().height() > 10) {
        $(this).css("display", "none");
      } else if (counter > 1) {
        $(this).css("display", "none");
      }
      counter++;
    } else {
      counter = 0;
    }
  });
  // $(".spacer-product-sections").each(function() {
  //   if (($(this).next().hasClass('spacer-product-sections') && $(this).height() > 10)) {
  //     $(this).next().css("display", "none");
  //   }
  //   if(($(this).prev().hasClass('spacer-product-sections') && $(this).prev().height() > 10)){
  //     $(this).css("display", "none");
  //   }
  // })
};
const comaprisonSectionTable = () => {
  $(".page-section.compare-section.metafileds-comaparison table td").each(
    function () {
      let textToChange = $(this).text();
      const regEX = /"(.*?)"/g;
      let newText = textToChange.replace(regEX, function (x) {
        return "</td><td>" + x;
      });
      if (
        $(this)
          .text()
          .match(/"(.*?)"/g) !== null &&
        $(this)
          .text()
          .match(/"(.*?)"/g).length >= 2
      ) {
        $(this)
          .parent("tr")
          .html($.parseHTML("<td>" + newText.replaceAll('"', "") + "</td>"));
      }
    }
  );
};
$(document).ready(function () {
  // activeHtmlInText();
  get_Aspect_ratio();
  remove_unnecessary_space();
  comaprisonSectionTable();
  $(window).resize(function () {
    get_Aspect_ratio();
  });
});

$(document).ready(() => {
  $(".js-mobile-search-toggle").click((e) => {
    e.preventDefault();
    e.stopPropagation();
    $(".search-mobile").css("display", "block");
    $(".search-mobile").css("opacity", "1");
  });
  $(".js-mobile-search-close").click((e) => {
    $(".search-mobile").css("display", "none");
    $(".search-mobile").css("opacity", "0");
  });
});

// CART UPDATES QTY
$(document).ready(function () {
  $(".quantity-table-cell").each(function () {
    $this = $(this);
    $this.find(".select-qty-input-cart").change(function () {
      let value = parseInt($(this).val()) - 1;
      $this.find(".cart-qty-input").attr("value", value.toString());
      $this
        .find(".cart-qty-input")
        .siblings(".js-qty__adjust--plus")
        .trigger("click");
    });
  });
});

// MINICART
$(document).ready(function () {
  $(".site-nav__link.site-nav__link--icon.js-drawer-open-cart").click(function (
    e
  ) {
    e.preventDefault();
    e.stopPropagation();
    $("#mini-cart").fadeIn(500);
    $("#mini-cart").css("display", "block");
    $("body").addClass("mini-cart-active");
    $("html").addClass("mini-cart-open");
  });

  $("#mini-cart").click(function (e) {
    var trg = e.target;

    if (
      trg.classList.contains("close-cart") ||
      trg.classList.contains("continue-shopping")
    ) {
      e.stopPropagation();
      e.preventDefault();
      $("body").removeClass("mini-cart-active");
      $("html").removeClass("mini-cart-open");
      $("#mini-cart").fadeOut(300);
      return;
    }

    if (
      !trg.classList.contains("btn") &&
      !trg.parentNode.classList.contains("cart-product-link")
    ) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (trg.classList.contains("remove-product")) {
      var key = trg.getAttribute("data-key");
      var updates = {};
      updates[key] = 0;

      $.ajax({
        url: "/cart/update.js",
        dataType: "json",
        method: "POST",
        data: {
          updates: updates,
        },
      }).done(function (data) {
        var row = document.querySelector(".cart-product.cart-product-" + key);
        if (row) row.remove();

        if (data.total_price > 0) {
          $("#mini-cart").removeClass("empty");
          $(".order-total-container span").text(
            "$" + (data.total_price / 100).toFixed(2) + " USD"
          );
        } else {
          $("#mini-cart").addClass("empty");
        }
        //         updateCart();
      });
    }
  });

  $("body").click(function (e) {
    if (
      $("body").hasClass("mini-cart-active") &&
      !$(e.target).hasClass("no-close")
    ) {
      $("body").removeClass("mini-cart-active");
      $("html").removeClass("mini-cart-open");
      $("#mini-cart").fadeOut(300);
    }
  });
});

$(document).ready(function () {
  if ($(".template-search .search-form .search-q").length) {
    var q = $(".template-search .search-form .search-q").val(),
      no_articles = false,
      no_pages = false;

    $.get(
      "/search?q=" + q + "&type=page",
      function (data) {
        $(".template-search .search-results .search-pages").html(
          $(data).find(".search-pages").html()
        );

        if ($(data).find(".search-pages").text().trim() == "") no_pages = true;

        $.get(
          "/search?q=" + q + "&type=article",
          function (data) {
            $(".template-search .search-results .search-articles-wrapper").html(
              $(data).find(".search-articles-wrapper").html()
            );

            if ($(data).find(".search-articles-wrapper").text().trim() == "")
              no_articles = true;

            if (no_pages && no_articles)
              $(
                ".template-search .search-results .search-posts-wrapper .no-results"
              ).addClass("active");
          }
        );
      }
    );
  }
});
$(document).on("click", ".template-search .search-nav a", function (e) {
  e.preventDefault();

  var type = $(this).data("type");

  $(".template-search .search-nav a").parents("li").removeClass("active");
  $(this).parents("li").addClass("active");

  if (type == "posts") {
    $(".template-search .search-results .search-posts-wrapper").addClass(
      "active"
    );
    $(".template-search .search-results .search-products-wrapper").removeClass(
      "active"
    );
  } else {
    $(".template-search .search-results .search-products-wrapper").addClass(
      "active"
    );
    $(".template-search .search-results .search-posts-wrapper").removeClass(
      "active"
    );
  }
});

// $(document).ready(function () {
//   $(".page-content--product .product__main-photos .image-wrap").each(
//     function () {
//       $(this).zoom({ url: $(this).find("img").data("zoom") });
//     }
//   );
// });

// setInterval(function () {
//   if (!$('.fotorama__stage .fotorama__loaded--img.fotorama__active:not(.fotorama__stage__frame--video) img.zoomImg').length) {
//     $('.fotorama__stage .fotorama__loaded--img.fotorama__active:not(.fotorama__stage__frame--video)').zoom();
//   }
// }, 0);

$(document).ready(function () {
  const headerSection = $('#shopify-section-custom-header');
  // var prevScrollpos = window.pageYOffset;
  // window.onscroll = function() {
  //   var currentScrollPos = window.pageYOffset;
  //   if (prevScrollpos > currentScrollPos) {
  //     // headerSection.css('transform', 'translateY(0)')
  //     headerSection.css('top', '0')
  //   } else {
  //     // headerSection.css('transform', 'translateY(-100%)')
  //     headerSection.css('top', '-200px')
      
  //   }
  //   prevScrollpos = currentScrollPos;
  // }
  let headerShown = true;
  let lastWindowScroll = $(window).scrollTop();

  $(window).scroll(function () {
    let windowScroll = $(window).scrollTop();

    if (lastWindowScroll < windowScroll && headerShown && windowScroll > 100) {
      if (
        !$(".drawer").hasClass("nav_open") &&
        !$("body").hasClass("mini-cart-active")
      ) {
        headerSection.addClass("header-hidden");
      }
      headerShown = false;
    } else if (!headerShown && lastWindowScroll > windowScroll) {
      if ($(window).width() <= 767) {
        headerSection.removeClass("header-hidden");
        headerShown = true;
      }
      if ($(window).width() > 767 && windowScroll <= 100) {
        headerSection.removeClass("header-hidden");
        headerShown = true;
      }
    }

    lastWindowScroll = windowScroll;
  });
});

$(
  '.cart__submit-control[name="checkout"], #mini-cart .cart-controls .btn:last-of-type'
).on("mouseup touchend", function (e) {
  $(
    '.cart__submit-control[name="checkout"], #mini-cart .cart-controls .btn:last-of-type'
  ).addClass("loading");
});
const resize_first_img_sec_mobile = () => {
  if ($(window).width() < 768) {
    let interval = setInterval(() => {
      if (
        $(
          ".product_img_text_1.big_mb_img .img-cont-outer > div.img-cont img"
        ).attr("sizes") !== ""
      ) {
        $(".product_img_text_1.big_mb_img .img-cont-outer > div.img-cont").attr(
          "style",
          `padding-top:${$(
            ".product_img_text_1.big_mb_img .img-cont-outer > div.img-cont img"
          ).height()}px!important`
        );
        $(".product_img_text_1.big_mb_img .img-cont-outer > div.img-cont").addClass("padding-top-calculated");
        clearInterval(interval);
      }
    }, 200);
  }
};
$(document).ready(function () {
  resize_first_img_sec_mobile();
  $(window).resize(function () {
    resize_first_img_sec_mobile();
  });
});

$(document).ready(function () {
  $(".header-subnav.medium-up--hide ul a").each(function () {
    if (window.location.href.includes($(this).attr("href"))) {
      $(this).addClass("go-red");
    }
  });
});
const hideElForTime = ($el, time) => {
  $el.css({ display: "none" });
  setTimeout(() => {
    $el.css({ display: "block" });
  }, time);
};

const getWidnowWidth = () => {
  let windowWidth = $(window).width();

  $(window).resize(function () {
    windowWidth = $(window).width();
  });

  return windowWidth;
};
const setBodyHeightForAnnocument = () => {
  if (getWidnowWidth() < 769) {
    setTimeout(() => {
      $("body.announcement-open").css("padding-top", `${$("#shopify-section-custom-header").height()}px` )
      $("body.header-icons-top-open").css("padding-top", `${$("#shopify-section-custom-header").height()}px` )
    }, 400)
    
  }
}
const fixMobileNav = () => {
  if ($(window).width() < 769) {
    let counter = 0;
    let $nav = $(".shopify-section.custom-header-section");
    let scrollTopVal = $nav.height() > 20 ? $nav.height() : 20;
    
    let timeScrolled = Date.now();
    $(window).scroll(function () {
      let timeNow = Date.now();
      if (getWidnowWidth() < 769 ) {
        if ($(window).scrollTop() > scrollTopVal && timeNow > timeScrolled) {
          $nav.addClass("mobile-header-fixed");
          $("body").addClass("paddng-hack");
          $("body").css("padding-top", `${$("#shopify-section-custom-header").height()}px` )
          
          if (counter == 0) {
            hideElForTime($nav, 300);
            counter++;
          }
          timeScrolled = Date.now() + 800
        } else if($nav.hasClass("mobile-header-fixed") && $(window).scrollTop() < 1 ) {
          setTimeout(function(){
            // $nav.removeClass("mobile-header-fixed");
            // $("body").removeClass("paddng-hack");
            counter = 0;
          }, 300)
          
        }
      } 
      // else {
      //   $nav.removeClass("mobile-header-fixed");
      //   $("body").removeClass("paddng-hack");
      //   counter = 0;
      // }
    });
  }
};
$(document).ready(function () {
  // fixMobileNav();
  setBodyHeightForAnnocument();
  $(window).resize(function () {
    //fixMobileNav();
    setBodyHeightForAnnocument();
  });
  
  
  $(".product__thumbs--scroller").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow: $(".product__thumb-arrow.product__thumb-arrow--prev"),
    nextArrow: $(".product__thumb-arrow.product__thumb-arrow--next"),
    infinite: true,
    speed: 300,
    waitForAnimate: true,
    focusOnSelect: true,
    //asNavFor: $(".template-product .product-section .product__main-photos .product-slideshow"),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  });
//   $(".template-product .product-section .product__main-photos .product-slideshow").slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     infinite: true,
//     speed: 300,
//     waitForAnimate: true,
//     focusOnSelect: true,
//     asNavFor: $(".product__thumbs--scroller")
//   });
//   $('.template-product .product-section .product__main-photos .product-slideshow').on('afterChange', function(event, slick, currentSlide, nextSlide){
//     $(".slick-slide").removeClass('is-selected');
//     $('.slick-current').addClass('is-selected');        
//  });
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    var attributeValue = $(mutation.target).prop(mutation.attributeName);
    $(".product__thumbs--scroller .product__thumb-item a.is-active").parent().trigger("click");
  });
});
setTimeout(function () {
  var gesuredZone = document.querySelector('.template-product .product-section .product__main-photos');
  if(gesuredZone !== null){
    gesuredZone.addEventListener('touchend', function(event) {
      const $parent = $(".product__thumbs--scroller .product__thumb-item a.is-active").trigger("click")
      
  }, false); 
  }
}, 1000);

  $(".product__thumb-arrow").click(function () {
    $(".product__thumb-arrow").prop("disabled", true);
    setTimeout(function () {
      $(".product__thumb-arrow").prop("disabled", false);
    }, 600);
  });

  $(".product__thumbs--scroller .product__thumb").each(function () {
    $(this).click(function (event) {
      event.preventDefault();
    });
  });
});

const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const timeEst = document.querySelector(".order-date__time-est");
if (timeEst != null) {
  const date = new Date();
  const fiveDays = new Date(date.getTime() + 5*24*60*60*1000)
  const sevenDays = new Date(date.getTime() + 7*24*60*60*1000)

  if (fiveDays.getDate() < sevenDays.getDate()) {
    timeEst.textContent = ` ${month[fiveDays.getMonth()]} ${fiveDays.getDate()} - ${sevenDays.getDate()} (USA)`
  } else {
     timeEst.textContent = ` ${month[fiveDays.getMonth()]} ${fiveDays.getDate()} - ${month[sevenDays.getMonth()]} ${sevenDays.getDate()} (USA)`
  }
  
  
  
}

// $(document).ready(function () {
//   if($('.announcement-bar.fixed').length > 0){
//      $('body').css({"padding-top": `${$('.announcement-bar.fixed').outerHeight()}px`})
//   console.log("HERE")

//     $(window).resize(function() {
//       if (window.screen.width > 768) {
//         $('body').css({"padding-top": `${$('.announcement-bar.fixed').outerHeight()}px`})
//       }
//     })
//   }
  
// })

